var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsNumber, IsOptional } from 'class-validator';
export class CreateDailyFeeDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "feeGradeId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateDailyFeeDto.prototype, "date", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "vehicleModelId", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "baseFee", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "offeredFee", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "option1Fee", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDailyFeeDto.prototype, "option2Fee", void 0);
